import gql from 'graphql-tag';

export const S3_file_download_generate_presigned_URL = gql`
  query S3_file_download_generate_presigned_URL($full_file_key: String!)
  {
    S3_file_download_generate_presigned_URL(full_file_key: $full_file_key)
    {
      status
      url
    }
  }`;

export const S3_file_upload_create_presigned_post_attributes = gql`
  query S3_file_upload_create_presigned_post_attributes($context: S3_FileContext_Type!, $parent_object_id: ID!, $file_already_exists_handling: S3_FileExistsErrorHandling_Type!, $file_name: String!){
    S3_file_upload_create_presigned_post_attributes(context: $context, parent_object_id: $parent_object_id, file_already_exists_handling: $file_already_exists_handling, file_name: $file_name){
      status
      confirmed_file_name
      formInputs
      formAttributes
      full_file_key
      file_hash
    }
  }`;
